import Vue from 'vue'
import Vuex from 'vuex'
import reviews from './modules/reviews'
import comments from './modules/comments'
import users from './modules/users'
import follows from './modules/follows'
import helpfuls from './modules/helpfuls'
import clips from './modules/clips'
import purchase from './modules/purchase'
import reports from './modules/reports'
import errors from '@/api/errors'

Vue.use(Vuex)

const commons = {
  namespaced: true,
  state: {
    isLoadingAll: false,
    isLoadingMore: false,
    isLoadingPost: false,
    isTargetNone: false,
    cookies: {},
    globalErrorMessage: undefined,
    authenticationErrorMessage: undefined
  },
  getters: {
    isLoadingAll: state => state.isLoadingAll,
    isLoadingMore: state => state.isLoadingMore,
    isLoadingPost: state => state.isLoadingPost,
    isTargetNone: state => state.isTargetNone,
    cookies: state => state.cookies,
    isGlobalError: state => state.globalErrorMessage !== undefined,
    globalErrorMessage: state => state.globalErrorMessage,
    isAuthenticationError: state => state.authenticationErrorMessage !== undefined,
    authenticationErrorMessage: state => state.authenticationErrorMessage,
    validateAccessToken: state => !!state.cookies['mchat']
  },
  mutations: {
    setLoadingAll: (state, args) => {
      state.isLoadingAll = args.isLoading
    },
    setLoadingMore: (state, args) => {
      state.isLoadingMore = args.isLoading
    },
    setLoadingPost: (state, args) => {
      state.isLoadingPost = args.isLoading
    },
    setTargetNone: (state, args) => {
      state.isTargetNone = args.isTargetNone
    },
    setCookies: (state, args) => {
      let cookies = {}
      for (let cookieMap of document.cookie.split(';')) {
        let cookieKeyValue = cookieMap.split('=')
        if (cookieKeyValue) {
          cookies[cookieKeyValue[0].trim()] = cookieKeyValue[1]
        }
      }
      state.cookies = cookies
    },
    setGlobalError: (state, error) => {
      if (error instanceof errors.AuthenticationError) {
        state.authenticationErrorMessage = error.message
      } else {
        state.globalErrorMessage = error.message
      }
    },
    clearGlobalError: (state) => {
      state.globalErrorMessage = undefined
      state.authenticationErrorMessage = undefined
    }
  },
  actions: {
    setLoadingAll: ({ commit }, args) => {
      commit('setLoadingAll', args)
    },
    setLoadingMore: ({ commit }, args) => {
      commit('setLoadingMore', args)
    },
    setLoadingPost: ({ commit }, args) => {
      commit('setLoadingPost', args)
    },
    setTargetNone: ({ commit }, args) => {
      commit('setTargetNone', args)
    },
    setCookies: ({ commit }, args) => {
      commit('setCookies', args)
    },
    setGlobalError: ({ commit }, error) => {
      commit('setGlobalError', error)
    },
    clearGlobalError: ({ commit }) => {
      commit('clearGlobalError')
    }
  }
}

export default new Vuex.Store({
  modules: {
    storeReviews: reviews,
    storeComments: comments,
    storeUsers: users,
    storeFollows: follows,
    storeHelpfuls: helpfuls,
    storeClips: clips,
    storePurchase: purchase,
    storeReports: reports,
    commons: commons
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js